import React from "react";
import { BRAND } from "@/config/brand";

// Prism prototype logo — geometric triangle (prism) with four thin colored
// rays at the base. Brand-agnostic; aria-label reads dynamically from BRAND.
export default function Logo({ size = 32, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={`${BRAND.name} Logo`}
      className={className}
      data-testid="brand-logo"
    >
      {/* Prism triangle */}
      <path
        d="M20 5 L33 28 L7 28 Z"
        fill="#FFFFFF"
        stroke="#0F172A"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      {/* Soft inner highlight */}
      <path
        d="M20 9 L20 28"
        stroke="#0F172A"
        strokeOpacity="0.12"
        strokeWidth="1.25"
        strokeLinecap="round"
      />

      {/* Four refracted rays */}
      <line
        x1="11"
        y1="28"
        x2="6"
        y2="36"
        stroke="#4563BB"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="17"
        y1="28"
        x2="15.5"
        y2="37"
        stroke="#FCD34D"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="23"
        y1="28"
        x2="24.5"
        y2="37"
        stroke="#EF4444"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="29"
        y1="28"
        x2="34"
        y2="36"
        stroke="#10B981"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
